const proxy = require('./devProxy');

const config = {
  // 签名密钥
  spk: '4ff22a35c78df1577480cb53dd785590',
  ThemeColor: '#FFE87B',
  lessModifyVars: {
    // less变量
    'primary-color': '#FAE47A',
    animationDelay: '0.6s cubic-bezier(0, 0, 0, 0.8)',
    maxWidth: '1528px',
  },
  // token 名称
  tk: 'x-token',
  CDN: `https://plat-cdn.manjuu.com/platform/OfficialWebsite/${process.env.APP_ENV}`,
  SENTRY_DSN: 'https://8afcab0259ecef6cff6f779b9c7ea6a3@sentry.manjuu.com/15',
  proxy,
  // 默认语言
  defaultLang: 'zh',
  lang: [
    'en', // 英语-海外默认语言
    'zh', // 大陆-简体中文
    'zh-tw', // 台湾-繁体中文
    'kr', // 韩语
    'jp', // 日语
  ],
};

module.exports = config;
